<template>
  <div class="book">
    <h1>{{ currentBook.title }}</h1>
    <div class="pdf-part row">
      <div class="column">
        <TopNavigation
            :bookmarks="userBookmarks"
            :viewMode="viewMode"
            :bookmarked="isBookmarked"
            @addBookmark="onAddBookmark"
            @removeBookmark="onRemoveBookmark"
            @changeViewMode="viewMode = $event"
        />
        <div class="row book-pdf">
          <PDF
              :src="currentBook.downloads[0].file"
              :page="currentPage"
              :text="false"
          >
            <template slot="loading">
              <app-loading :loading="true">
              </app-loading>
            </template>
          </PDF>
          <PDF
              :src="currentBook.downloads[0].file"
              :page="currentPage + 1"
              :text="false"
              v-if="viewMode === 'two-page'"
          >
            <template slot="loading">
              <app-loading :loading="true">
              </app-loading>
            </template>
          </PDF>
        </div>
        <BottomButtons :currentPageProp="currentPage" @change="currentPage = $event"/>
      </div>
      <Bookmarks @selected="currentPage = $event" :bookmarks="userBookmarks"/>
    </div>
  </div>
</template>

<script>
import PDF from "pdfvuer";
import Bookmarks from '@/components/market/Bookmarks'
import BottomButtons from "@/components/market/book/BottomButtons";
import TopNavigation from "@/components/market/book/TopNavigation";

export default {
  name: "Book",
  data() {
    return {
      currentPage: 1,
      viewMode: 'two-page',
      userBookmarks: [
        {
          pageNumber: 1,
          title: 'Test bookmark 1'
        },
        {
          pageNumber: 2,
          title: 'Test bookmark 2'
        },
        {
          pageNumber: 3,
          title: 'Test bookmark 3'
        },
        {
          pageNumber: 4,
          title: 'Test bookmark 4'
        },
        {
          pageNumber: 34,
          title: 'Test bookmark 34'
        }
      ],
    }
  },
  components: {
    BottomButtons,
    PDF,
    Bookmarks,
    TopNavigation
  },
  methods: {
    onAddBookmark() {
      this.userBookmarks.push({
        pageNumber: this.currentPage,
        title: 'New bookmark name'
      });
    },
    onRemoveBookmark() {
      this.userBookmarks = this.userBookmarks
          .filter(bookmark => bookmark.pageNumber !== this.currentPage)
    }
  },
  computed: {
    currentBook () {
      return this.$store.getters['market/getProductById'](this.$route.params.id);
    },
    isBookmarked: function () {
      return !!~this.userBookmarks
          .map( ({pageNumber}) => pageNumber )
          .indexOf(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.book {
  padding-left: 20px;
  .row {
    display: flex;
  }
  .column {
    display: flex;
    flex-direction: column;
  }
  .pdf-part {
    display: flex;
    &>.column {
      width: 80%;
    }
    .book-pdf>div {
      width: 50%;
    }
  }
  .bottom-buttons {
    display: flex;
    justify-content: center;
    padding: 20px 0;
    .pagination-info {
      display: flex;
      align-items: center;
      margin-left: 10px;
      margin-right: 10px;
      .currentPage {
        outline: none;
        border: none;
        color: #9EC360;
        background-color: #fff;
        border-radius: 5px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 5px;
      }
    }
  }
}
</style>